var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.5,
    r: 20,
    fill: "#17C5D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 16.5C26.5 17.8807 25.3807 19 24 19C22.6193 19 21.5 17.8807 21.5 16.5C21.5 15.1193 22.6193 14 24 14C25.3807 14 26.5 15.1193 26.5 16.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23.5V32.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationAlert);
export default __webpack_public_path__ + "static/media/information-alert.8a16d64c87c4ed36ad9b6020c3e81004.svg";
export { ForwardRef as ReactComponent };